<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Ay</label>
            <v-select-list :options="months" label="name" placeholder="Ay" v-model="month"></v-select-list>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Yıl</label>
            <v-select-list :options="years" placeholder="Yıl" v-model="value.Year"></v-select-list>
        </div>
        <div class="col-12">
            <v-file-uploader :accept="['xls','xlsx']" :value="value" value-parameter="File"></v-file-uploader>
        </div>
    </div>
</template>

<script>
import VFileUploader from '@/components/v-file-uploader/VFileUploader.vue'

export default {
    components:{
        VFileUploader,
    },
    props:{
        value:Object,
        years:Array,
        months:Array,
        uploadingPayroll:Boolean,
        uploadingTicket:Boolean,
        ticketErrors:Array
    },
    computed:{
        month:{
            get:function(){
                return this.months.find(s=>s.index==this.value.Month)
            },
            set:function(value){
                this.value.Month = value?.index || null
            }
        }
    }
}
</script>

<style>

</style>